import _sfc_main from "./component-library121.mjs";
import normalizeComponent from "./component-library92.mjs";
var _sfc_render = function render() {
  var _vm = this, _c = _vm._self._c, _setup = _vm._self._setupProxy;
  return _c(_setup.InputWrapper, _vm._b({ scopedSlots: _vm._u([{ key: "default", fn: function({ id: wrapperId }) {
    return [_c("input", _vm._b({ ref: "primaryInput", staticClass: "input-wrapper__input", class: _vm.inputClass, attrs: { "id": wrapperId, "aria-invalid": !!_vm.errorMessage, "aria-describedby": `${wrapperId}-error` }, on: { "input": _setup.onInput, "focus": _setup.onFocus } }, "input", _setup.inputFieldProps, false))];
  } }]) }, "InputWrapper", _setup.inputWrapperProps, false));
};
var _sfc_staticRenderFns = [];
var __component__ = /* @__PURE__ */ normalizeComponent(
  _sfc_main,
  _sfc_render,
  _sfc_staticRenderFns,
  false,
  null,
  null,
  null,
  null
);
const TextInput = __component__.exports;
export {
  TextInput as default
};
